// We check what language is set for the body
const lang = document.querySelector("html").getAttribute("lang") || (document.querySelector("body").getAttribute("lang") || document.querySelector("#app").getAttribute("lang")).split('-')[0]
if (lang == undefined) {
    throw new Error("No language was set. Set it as <html lang='lng'>")
}

export default lang